import { appstr } from "../utils/appstr";
import { BuildFontString } from "../utils/BuildFontString";
import { CreateCanvas } from "../utils/CreateCanvas";
import { Div2Floor } from "../utils/Div2Floor";
import { doDrawImage } from "../utils/doDrawImage";
import { doDrawImage3 } from "../utils/doDrawImage3";
import { XML_DrawCellChartPPT } from "../utils/XML_DrawCellChartPPT.js";
import { CreateRegExpression } from "../utils/CreateRegExpression.js";
import { MeasureText } from "../utils/MeasureText.js";
import { SVG_DrawText } from "../utils/SVG_DrawText.js";
import { ConvertToGrayscaleImage } from "../utils/ConvertToGrayscaleImage.js";
import { isInStandardSubmode } from "../utils/isInStandardSubmode.js";
import { QBoxCellObj } from "./QBoxCellObj.js";
import { CenterIt } from "../utils/CenterIt.js";
import { QChartBox } from "./QChartBox.js";

import {
  enumBorderLineType,
  enumBoxOverlay,
  enumBoxShapes,
  enumBoxSubTypes,
  enumCellContentType,
  enumCellObjectSubtypes,
  enumChartBoxInteractionMode,
  enumElementLayer,
  enumFieldDisplayMode,
  enumFillMode,
  enumHierarchyTypes,
  enumOverrideType,
  enumPicMask,
  enumPictureType,
  enumXMLType,
  kEscKey,
  kOCNDarkGrayColor,
  kReturnKey,
  kTabKey
} from "../constants";
import { GetFieldLabel } from "../utils/GetFieldLabel";
import { isInViewer } from "../utils/isInViewer";
import { isInViewManager } from "../utils/isInViewManager";
import { performStroke } from "../utils/performStroke";
import { QBoxOverlay_Wand } from "./QBoxOverlay_Wand";
import { QRecordDetailsRFC } from "./QRecordDetailsRFC";
import { QRect } from "./QRect";
import { QTextEditBase } from "./QTextEditBase";
import { SVG_DrawCellChart } from "../utils/SVG_DrawCellChart";
import { SVG_DrawImage } from "../utils/SVG_DrawImage";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { TruncateText } from "../utils/TruncateText";
import { XML_DrawCellChartPDF } from "../utils/XML_DrawCellChartPDF";
import { XML_DrawImage } from "../utils/XML_DrawImage";
import { XML_DrawText } from "../utils/XML_DrawText";
import { Globals } from "./Globals";
import { CreatePath2D } from "../utils/CreatePath2D";

export class QChartBoxCell extends QTextEditBase {
  constructor() {
    //this.fBoxCellID = gBoxCellCounter++;

    super();
    this.fWSMgr = null;
    this.fLayout = null;
    this.fCellDesc = null;
    this.fParentBox = null;
    this.fElements = [];
    //this.fEditMode = enumLayoutCellEditMode.readOnly;

    //this.fCellMode = null;
    this.fCellEditMode = false;

    this.fCellDrawBuffer = null;

    this.fDataObj = null;
    this.fDataObjID = null;

    this.fRenderBorderGrid = false;
    this.fOutlineSelection = false;
    this.fPreviewMode = false;

    this.fForceClip = false;
    this.fCurCursor = null;

    this.fAutoTextCache = null;

    this.fImage = null;
    this.fMaskedImage = null;

    this.fObjectName = "QChartBoxCell";

    this.fRedoContent = null;
    this.fCanUndo = false;
    this.fClosed = false;
  }

  /*
function GetSCNodeRef(layout)
{
    var nodeList = new Array();
    var scNode = layout.GetSCNodeRef();
    nodeList.push(scNode);
    return nodeList;
}
*/
  SubscriberImageLoaded() {
    var c = this.fCellDesc;
    if (this.fClosed) {
      //console.log("QChartBoxCell.SubscriberImageLoaded disposed before callback complete");
      return;
    }

    this.fImage = c.LoadCellPicture(null);
  }

  ImageLoaded(pRef, redraw) {
    var c = this.fCellDesc;
    if (this.fClosed) {
      //console.log("QChartBoxCell.ImageLoaded disposed before callback complete");
      return;
    }

    if (!pRef.fIsURL) {
      var pictureType = this.GetPictureType();
      if (pictureType != enumPictureType.staticPicture) {
        var curInfo = c.GetPicSourceInfo();
        if (!curInfo.Equal(pRef.fDirectory, pRef.fFileName)) {
          // var l = this.fLayout;
          var w = this.fWSMgr;
          if (w) w.StartCheckPoint();
          c.SetCellPictureInfo(pRef.fDirectory, pRef.fFileName);
          if (w) w.EndCheckPoint();
        }
      }
    }
    this.fImage = c.LoadCellPicture(null);

    /*
	if (this.fImage)
        console.log("ImageLoaded - ",this.fBoxCellID);
    else
        console.log("ImageLoaded - image null -",this.fBoxCellID);
*/

    if (redraw) {
      //console.log("ImageLoaded - ",this.fBoxCellID);

      var wsMgr = pRef.fWSMgr;
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
    }
  }

  // 2.1.3
  InitLayoutCell(cellDesc, theLayout, parentBox, dataObj) {
    this.fDataObj = dataObj;

    if (dataObj) this.fDataObjID = dataObj.GetObjectID();

    this.fCellDesc = cellDesc;
    this.fLayout = theLayout;
    this.fParentBox = parentBox;

    if (this.IsAutoText()) {
      this.CacheAutoText();
      parentBox.SetAutoTextRef(this);
    }

    if (this.IsPicture()) {
      this.fCellDesc.fDeferredPicLoad = true;
      //	this.fImage = this.fCellDesc.LoadCellPicture(this);
    }
    if (
      theLayout.GetBoxSubType() === enumBoxSubTypes.enumeratedTable ||
      theLayout.GetBoxSubType() === enumBoxSubTypes.refChart
    ) {
      theLayout.fDeferredTableLoad = true;
    }

    if (this.IsObject()) {
      var curDoc = theLayout.GetDocRef();
      if (this.fDataObj) {
        var cellField = this.GetField();
        var cellValue = this.fDataObj.GetFieldValue(cellField, false);
        switch (this.ObjectSubtype()) {
          case enumCellObjectSubtypes.alsoreportsto:
            var addedIDs = [];
            var recordIDKey =
              curDoc.GetHierarchyType() === enumHierarchyTypes.positions
                ? "PositionID"
                : "PersonID";
            var recordSupervisorKey =
              curDoc.GetHierarchyType() === enumHierarchyTypes.positions
                ? "Parent PositionID"
                : "SupervisorID";
            var mySupervisor = this.fDataObj.SmartGetFieldValue(recordSupervisorKey);
            for (var i in cellValue) {
              var anOption = cellValue[i]; // backend obj
              if (
                anOption[recordIDKey] !== mySupervisor &&
                addedIDs.indexOf(anOption[recordIDKey]) < 0
              ) {
                if (this.fElements.length < 1) {
                  //enumFieldDisplayMode.LabelAndField
                  if (cellDesc.GetFieldDisplayMode() === enumFieldDisplayMode.LabelAndField) {
                    var newBoxCellObj = new QBoxCellObj();
                    if (curDoc.GetHierarchyType() === enumHierarchyTypes.positions)
                      var label = {
                        Title: this.GetField().GetFieldLabel() + ":",
                        PositionID: ""
                      };
                    else
                      label = {
                        Name: this.GetField().GetFieldLabel() + ":",
                        PersonID: ""
                      };
                    newBoxCellObj.InitBoxCellObj(
                      this,
                      this.GetField(),
                      label,
                      this.ObjectSubtype()
                    );
                    newBoxCellObj.fIsLabel = true;
                    this.PushElement(newBoxCellObj);
                  }
                }
                var newBoxCellObj = new QBoxCellObj();
                newBoxCellObj.InitBoxCellObj(this, this.fFieldDef, anOption, this.ObjectSubtype());
                newBoxCellObj.SetCursor("pointer");
                //TODO: dynamic? use PersonID fieldDef?
                newBoxCellObj.fCmdCode = "NavToBox";
                this.PushElement(newBoxCellObj);
                addedIDs.push(anOption[recordIDKey]);
              }
            }
            break;
          default:
            console.log("unhandled");
            break;
        }
      }
    }

    this.SetLayer(parentBox.GetLayer());

    this.SetEnabled(false);
    this.SetIsControl(false);
    this.SetIsSelectable(false);
    this.SetAutoResize(true);

    this.InitTextEditBase();
  }

  PositionElements(buffer) {
    if (!this.fElements || this.fElements.length < 1) return;
    var eleStructure = [[]];

    if (buffer == null) buffer = 0;
    var elementList = this.fElements;
    var rowHeight = elementList[0].GetHeight();
    var maxRows = Math.ceil(this.GetHeight() / rowHeight);
    var yPos = this.GetPositionY();
    var startingX = this.GetPositionX() + this.GetCellHPadding();
    var curX = startingX;
    var rightBorder = this.GetWidthPositionX();
    var index = 0;
    for (var eleIdx = 0; eleIdx < elementList.length; eleIdx++) {
      var curElement = elementList[eleIdx];
      if (curX + buffer + curElement.GetWidth() + curElement.GetSeparatorWidth() > rightBorder) {
        if (index === maxRows) break;
        // do not drop to next available row unless another ele is present in curRow
        if (eleStructure[index].length > 0) {
          index += 1;
          eleStructure[index] = [];
          curX = startingX;
          yPos += rowHeight;
        }
      }
      curElement.PositionElement(curX, yPos);
      eleStructure[index].push(curElement);
      curX += curElement.GetWidth() + curElement.GetSeparatorWidth() + buffer;
    }
    this.AlignElements(eleStructure);
    this.fCellDesc.f2DElements = eleStructure;
  }

  AlignElements(elementArray) {
    this.AlignElementsH(elementArray);
    this.AlignElementsV(elementArray);
  }

  AlignElementsV(elementArray) {
    var theAlignment = this.TEGetVAlignment();
    var rowHeight = this.fElements[0].GetHeight();
    var remainingHeight = this.GetHeight() - elementArray.length * rowHeight;
    if (remainingHeight <= 0) return;
    var shiftY = 0;
    switch (theAlignment) {
      case "bottom":
        shiftY = remainingHeight;
        break;
      case "middle":
        shiftY = remainingHeight / 2;
        break;
    }
    for (var rowIdx = 0; rowIdx < elementArray.length; rowIdx++) {
      var elementRow = elementArray[rowIdx];
      for (var anElement = 0; anElement < elementRow.length; anElement++) {
        var curElement = elementRow[anElement];
        curElement.SetPositionY(curElement.GetPositionY() + shiftY);
      }
    }
  }

  AlignElementsH(elementArray) {
    var theAlignment = this.TEGetAlignment(false);
    var rightBorder = this.GetWidthPositionX() - this.GetCellHPadding();
    for (var rowIdx = 0; rowIdx < elementArray.length; rowIdx++) {
      var elementRow = elementArray[rowIdx];
      var lastEle = elementRow[elementRow.length - 1];
      var remainingHSpace =
        rightBorder - (lastEle.GetPositionX() + lastEle.GetWidth() + lastEle.GetSeparatorWidth()); // should probably consolidate this width into 1 function
      if (remainingHSpace < 0) remainingHSpace = 0;
      var shiftX = 0;
      switch (theAlignment) {
        case "center":
          shiftX = remainingHSpace / 2;
          break;
        case "left":
          break;
        case "right":
          shiftX = remainingHSpace;
          break;
      }
      for (var anElement = 0; anElement < elementRow.length; anElement++) {
        var curElement = elementRow[anElement];
        curElement.SetPositionX(curElement.GetPositionX() + shiftX);
      }
    }
  }

  PositionElement(x, y) {
    this.fHorzOffset = x;
    this.fVertOffset = y;
    this.PositionElements();
  }

  //======================================================================
  // Undo/Redo
  CanUndo() {
    return this.fCanUndo;
  }

  CanRedo() {
    return this.fRedoContent != null;
  }

  Redo() {
    this.SetEditContent(this.fRedoContent);
    this.SetInsertAtEnd();

    this.fRedoContent = null;
  }

  Undo() {
    var cc = this.GetEditContent();
    this.CacheContent();
    this.SetInsertAtEnd();
    this.fRedoContent = cc;
    this.fCanUndo = false;
  }

  ContentChanged() {
    if (this.InEditMode()) this.fCanUndo = true;
  }

  HasSubCursor() {
    //if (this.fParentBox)
    //	this.fParentBox.SetAutoHyper(null);
    return Globals._accountInfo.ReadOnlyMode();
  }

  GetSubCursor(hitTest) {
    var isHyper = this.IsHyperLink();
    if (isHyper) return "pointer";
    else return this.GetCursor();
  }

  GetCursor() {
    return this.fCurCursor;
  }

  GetPreviewMode() {
    return this.fParentBox.GetPreviewMode();
  }

  GetForceClip() {
    var forceClip = this.fForceClip;
    if (forceClip == false) return false;

    // Special optimization - no need to clip if a rectangle within a rectangle
    var p = this.fParentBox;
    var boxShape = p.GetBoxShapeType();
    if (boxShape == enumBoxShapes.rectangle) {
      var cellBottom = this.GetPositionY() + this.GetHeight();
      var boxBottom = p.GetPositionY() + p.GetHeight();
      if (cellBottom <= boxBottom) return false;
    }

    return true;
  }

  SetForceClip(forceClip) {
    this.fForceClip = forceClip;
  }

  GetSPictureScaleH() {
    var c1 = this.GetCellDesc();
    return c1.GetSPictureScaleH();
  }

  GetSPictureScaleW() {
    var c1 = this.GetCellDesc();
    return c1.GetSPictureScaleW();
  }

  IsEditable() {
    if (this.IsFreeText()) return true;

    var c = this.GetCellDesc();
    var contentType = c.GetCellContentType();
    if (contentType == enumCellContentType.Field || contentType == enumCellContentType.FreeText) {
      if (!this.IsPicture() && !this.IsRefTableCell()) return true;
    }

    return false;
  }

  IsRefTableCell() {
    var isRefTableCell = false;
    var c = this.GetCellDesc();
    if (c.IsRefBox()) {
      var contentType = c.GetCellContentType();
      if (
        (contentType == enumCellContentType.Field || contentType == enumCellContentType.pieChart) &&
        !this.IsPicture()
      )
        isRefTableCell = true;
    }

    return isRefTableCell;
  }

  IsMergedCell() {
    var c = this.GetCellDesc();
    return c.IsMergedCell();
  }

  GetPictureType() {
    var c = this.GetCellDesc();
    return c.GetPictureType();
  }

  EnableContent() {
    this.SetIsControl(false);

    var isAutoText = this.IsAutoText();
    var isRefCell = this.IsRefTableCell();
    var isPicture = this.IsPicture();
    const isPosField = this.GetField()?.IsPositionField() && this.GetField()?.fFormulaRule === null;

    var pictureType = this.GetPictureType();
    var stdCell = !isAutoText && !isPicture && !isRefCell;
    var enabled = !isAutoText && !(pictureType == enumPictureType.staticPicture);

    this.SetEnabled(enabled);
    this.SetIsSelectable(enabled);

    var inViewEditorMode = isInViewManager();

    if (!Globals._accountInfo.ReadOnlyMode() || inViewEditorMode) {
      if (stdCell || isPosField) {
        this.SetDblClickCmd("EditCellContent");
        this.fCurCursor = "text";
      } else if (isPicture) {
        if (!this.FieldReadOnly() && Globals._uiConfig.fCanFilemgr)
          this.SetDblClickCmd("SelectCellImageFile"); //"CellImageProperties"
      }
    }
  }

  GetLinkTarget() {
    var cellDesc = this.GetCellDesc();

    return this.RetrieveEditContent();
  }

  GetLinkType() {
    var cellDesc = this.GetCellDesc();
    return cellDesc.GetLinkType();
  }

  IsActiveOutsideRenderLayer() {
    return this.GetLinkType() !== false;
  }

  IsHyperLink() {
    var cellDesc = this.GetCellDesc();
    return cellDesc.IsHyperLink();
  }

  GetRightClickActionList() {
    var cellDesc = this.GetCellDesc();
    var actionList = cellDesc.GetRightClickActionList();
    if (this.InEditMode()) {
      //TODO: make this work.
      //actionList.push('docut');
    }
    return actionList;
  }

  CellHandleRightClick(x, y) {
    Globals._wsMgr.DoHandleActCellContent(this, Globals._wsMgr.fCanvasPanel, x, y);
  }

  SetCellMode(newCellMode) {
    // Is there something that needs to be done for a cell that is in edit mode?
    // or will the deselect of the cell always take care of business

    this.fCurCursor = null;
    var cellLayout = this.fCellDesc;
    this.SetDblClickCmd(null);
    this.SetOutlineSelection(false);
    this.SetForceClip(false);

    // OCN5-6535: gutter cells stay visible but inert in the editor (no select/fill).
    if (
      cellLayout.IsGutterCell() &&
      (newCellMode === enumChartBoxInteractionMode.layout ||
        newCellMode === enumChartBoxInteractionMode.marquee)
    ) {
      this.SetEnabled(false);
      this.SetIsControl(false);
      this.SetIsSelectable(false);
      this.SetRenderBorderGrid(true);
      this.SetForceClip(true);
      return;
    }

    switch (newCellMode) {
      case enumChartBoxInteractionMode.readOnly:
      case enumChartBoxInteractionMode.boxstyle:
        this.SetEnabled(false);
        this.SetIsControl(false);
        this.SetIsSelectable(false);
        this.SetRenderBorderGrid(false);
        this.SetForceClip(true);
        break;
      case enumChartBoxInteractionMode.content:
        var cellDesc = this.fCellDesc;
        var gutterCell = cellDesc.IsGutterCell();
        if (!gutterCell) {
          var disableCell = this.IsPicture() && Globals._accountInfo.ReadOnlyMode();
          if (!disableCell) this.EnableContent();
        } else {
          this.SetEnabled(false);
          this.SetIsControl(false);
          this.SetIsSelectable(false);
        }
        this.SetRenderBorderGrid(false);
        this.SetForceClip(true);
        break;
      case enumChartBoxInteractionMode.layout:
        if (this.IsFreeText()) {
          this.EnableContent();
          this.SetIsControl(true);
          this.SetRenderBorderGrid(true);
          this.SetOutlineSelection(true);
        } else {
          this.SetEnabled(true);
          this.SetIsControl(true);
          this.SetIsSelectable(false);
          this.SetRenderBorderGrid(true);
          this.SetOutlineSelection(true);
        }
        break;
      case enumChartBoxInteractionMode.marquee:
        this.SetEnabled(true);
        this.SetIsControl(false);
        this.SetIsSelectable(false);
        this.SetRenderBorderGrid(true);
        this.SetOutlineSelection(true);
        break;
    }
  }

  Reselect() {
    if (this.fParentBox && this.IsHyperLink()) this.fParentBox.HandleHyperlink(this);
  }

  GetIsObject() {
    var cellDesc = this.GetCellDesc();
    return cellDesc.IsObject();
  }

  DoSetSelected(priorState, selected) {
    if (this.GetIsObject()) {
      return;
    }

    if (this.InEditMode() && selected == false) this.ExitEditMode();

    if (selected) this.Reselect();

    /*
                                     if (selected)
                                      console.log("Selecting a cell");
                                    else
                                      console.log("Deselecting a cell");
                                    */
  }

  GetGrabberHeight() {
    var theHeight = 6;
    var cellHeight = this.GetHeight();
    if (cellHeight < theHeight) theHeight = cellHeight;

    return theHeight;
  }

  GetCellDesc() {
    return this.fCellDesc;
  }

  SetWidth(theWidth) {
    return this.fCellDesc.SetCellWidth(theWidth);
  }

  GetWidth() {
    return this.fCellDesc.GetCellWidth();
  }

  SetHeight(theHeight) {
    //this.fLayout.SetBoxHeight(theHeight);
  }

  GetHeight() {
    var height = this.fCellDesc.GetCellHeight();
    if (this.InEditMode()) {
      var maxRows = this.GetNumRows(true);
      var actualRows = this.GetNumRows(false);
      if (actualRows > maxRows) height = Math.round((height / maxRows) * actualRows);
    }
    return height;
  }

  RenderSelectionHighlight(drawBuffer) {
    // For now I do not see a need for rendering a selection highlight on ART cells.
    // This can change... However since the purpose is to choose individual values within the cell,
    // highlighting the entire cell seems unnecessary.
    if (this.InEditMode() || this.TreatAsObject()) return;

    var ctx = drawBuffer.getContext("2d");

    ctx.save();

    //ctx.fillStyle = "#CAE5FF";
    //ctx.fillStyle = "#000000";
    ctx.fillStyle = "#CAE5FF";
    ctx.lineCap = "square";
    ctx.strokeStyle = "#000000";
    ctx.lineWidth = 1;

    var outline = this.OutlineSelection();

    var thickness = 0;
    if (outline) thickness = ThicknessAdjuster(1);

    var elementW = this.GetWidth();
    var elementH = this.GetHeight();

    /*
                                                    var wInset = 1;
                                                    if (elementW < 5)
                                                      wInset = 0;
                                                    var hInset = 1;
                                                    if (elementH < 5)
                                                      hInset = 0;
                                                    */

    var panelX = this.GetPositionX();
    var panelY = this.GetPositionY();

    /*
                                                    var boxLeft = panelX + 1 + thickness;
                                                    var boxTop = panelY + 1 + thickness;
                                                    var boxRight =panelX + this.GetWidth() - 1 + thickness;
                                                                                                        var boxBottom = panelY + this.GetHeight() - 1 + thickness;
                                                                                                                                                            */
    var boxLeft = panelX;
    var boxTop = panelY;
    var boxRight = panelX + this.GetWidth();
    var boxBottom = panelY + this.GetHeight();

    ctx.beginPath();
    ctx.moveTo(boxLeft, boxTop);
    ctx.lineTo(boxRight, boxTop);
    ctx.lineTo(boxRight, boxBottom);
    ctx.lineTo(boxLeft, boxBottom);
    ctx.lineTo(boxLeft, boxTop);
    ctx.closePath();

    ctx.globalCompositeOperation = "source-over";
    ctx.globalAlpha = 0.5; // 0.2;
    ctx.fill();

    //var editMode = this.GetEditMode();
    //if (editMode != enumLayoutCellEditMode.cellSelect)
    //{
    /*
                                                    if (this.OutlineSelection())
                                                    {
                                                       ctx.globalAlpha=1.0;
                                                      ctx.stroke();
                                                    }
                                                    */
    //}

    //	ctx.strokeRect(boxLeft, boxTop,boxWidth,boxHeight );
    ctx.restore();
  }

  OutlineSelection() {
    return this.fOutlineSelection;
  }

  SetOutlineSelection(outlineSelection) {
    this.fOutlineSelection = outlineSelection;
  }

  SetField(aField) {
    this.fCellDesc.SetField(aField);
  }

  SetupPictureCell() {
    const layoutPanel = this.fParentPanelRef;
    const layout = layoutPanel?.GetLayout();
    if (!layoutPanel || !layout) return;

    if (layout.fNumCols === 1) return;

    // Calculate the row's height when the cell is NOT a picture
    const cellDesc = this.GetCellDesc();
    const initField = cellDesc.GetField();
    const initNativePicFrame = cellDesc.GetNativePictureFrame();
    const initOverridePicFrame = cellDesc.GetOverridePictureFrame();
    cellDesc.SetField(null);
    const initRowHeight = this.GetBoxRowHeight();
    cellDesc.SetField(initField);
    cellDesc.SetPictureFrame(initNativePicFrame);
    if (initOverridePicFrame) cellDesc.SetOverridePictureFrame(initOverridePicFrame);

    if (initRowHeight < this.GetBoxRowHeight()) {
      this.GrowBoxToFitPicture(initRowHeight);
    } else {
      this.ShrinkBoxForPicture(initRowHeight);
    }

    layoutPanel.BuildLayout(layout, true);
  }

  GrowBoxToFitPicture(targetHeight) {
    const layoutPanel = this.fParentPanelRef;
    const layout = layoutPanel?.GetLayout();
    if (!layoutPanel || !layout) return;

    const cellDesc = this.GetCellDesc();
    const x = cellDesc.GetColIndex();
    const y = cellDesc.GetRowIndex();

    const cellList = [cellDesc];
    const mergeY = cellDesc.GetMergeY();
    for (let i = 0; i < mergeY; i++) {
      cellList.push(layout.GetCellDesc(x, y + i));
    }

    while (targetHeight < this.GetBoxRowHeight()) {
      if (!layout.IsEmptyCell(x, y + cellList.length)) {
        layoutPanel.DoRowInsert(false);
      }

      const adjacentCell = layout.GetCellDesc(x, y + cellList.length);
      cellList.push(adjacentCell);
      layout.DoMergeCells(cellList);
    }
  }

  ShrinkBoxForPicture(targetHeight) {
    const layoutPanel = this.fParentPanelRef;
    const layout = layoutPanel?.GetLayout();
    if (!layoutPanel || !layout) return;

    const cellDesc = this.GetCellDesc();
    const x = cellDesc.GetColIndex();
    const y = cellDesc.GetRowIndex();

    let revertLastShrink = false;

    while (targetHeight >= this.GetBoxRowHeight() && cellDesc.GetMergeY() > 0) {
      revertLastShrink = true;
      const mergeY = cellDesc.GetMergeY();
      const lastMergedCell = layout.GetCellDesc(x, y + mergeY);
      lastMergedCell.SetHidden(false);
      lastMergedCell.SetField(null);
      lastMergedCell.SetCellContentType(enumCellContentType.FreeText);
      cellDesc.SetMergeY(mergeY - 1);
    }

    if (revertLastShrink) {
      const mergeY = cellDesc.GetMergeY();
      const lastShrinkedCell = layout.GetCellDesc(x, y + mergeY + 1);
      lastShrinkedCell.SetHidden(true);
      lastShrinkedCell.SetField(null);
      cellDesc.SetMergeY(mergeY + 1);
    }
  }

  GetBoxRowHeight() {
    const layoutPanel = this.fParentPanelRef;
    const layout = layoutPanel?.GetLayout();
    if (!layoutPanel || !layout) return;

    const cellDesc = this.GetCellDesc();
    const sourceRow = cellDesc.GetRowIndex();

    const rowHeights = [];
    const yCount = layout.fNumRows + 2;

    for (let y = yCount - 1; y >= 0; y--) {
      const rowH = layout.CalcRowHeight(y, rowHeights);
      rowHeights.push(rowH);
      if (y === sourceRow) {
        return rowH;
      }
    }

    return -1;
  }

  ReplaceMerge(srcCell) {
    const layoutPanel = this.fParentPanelRef;
    const layout = this.GetLayout();
    if (!layoutPanel || !layout) return;

    const srcDesc = srcCell.GetCellDesc();
    const mergeX = srcDesc.GetMergeX();
    const mergeY = srcDesc.GetMergeY();
    layout.DoUnmergeCells([srcDesc]);

    const cellDesc = this.GetCellDesc();
    const x = cellDesc.GetColIndex();
    const y = cellDesc.GetRowIndex();

    const cellList = [cellDesc];

    for (let i = 0; i < mergeY; i++) {
      let adjacentCell = layout.GetCellDesc(x, y + i + 1);
      if (adjacentCell !== srcDesc && !layout.IsEmptyCell(x, y + i + 1)) {
        layoutPanel.DoRowInsert(false);
        adjacentCell = layout.GetCellDesc(x, y + i + 1);
      }
      cellList.push(adjacentCell);
    }

    for (let i = 0; i < mergeX; i++) {
      let adjacentCell = layout.GetCellDesc(x + i + 1, y);
      if (adjacentCell !== srcDesc && !layout.IsEmptyCell(x + i + 1, y)) {
        layoutPanel.DoColInsert(false);
        adjacentCell = layout.GetCellDesc(x + i + 1, y);
      }
      cellList.push(adjacentCell);
    }

    layout.DoMergeCells(cellList);
  }

  GetField() {
    return this.fCellDesc.GetField();
  }

  GetLayout() {
    return this.fLayout;
  }

  DrawBorderSegment(drawBuffer, sx, sy, ex, ey, whichSegment, lineWidth, noOverlap) {
    var cellDesc = this.fCellDesc;
    var gutterCell = cellDesc.IsGutterCell();
    var rowIndex = cellDesc.GetRowIndex();
    var colIndex = cellDesc.GetColIndex();

    var noDraw = false;

    if (gutterCell) {
      switch (whichSegment) {
        case enumBorderLineType.leftBorder:
          if (colIndex == 0) noDraw = true;
          break;
        case enumBorderLineType.rightBorder:
          var numCols = this.fLayout.GetNumCols() + 1;
          if (colIndex == numCols) noDraw = true;
          break;
        case enumBorderLineType.topBorder:
          if (rowIndex == 0) noDraw = true;
          break;
        case enumBorderLineType.bottomBorder:
          var numRows = this.fLayout.GetNumRows() + 1;
          if (rowIndex == numRows) noDraw = true;
          break;
      }
    }

    if (noDraw) return;

    var ctx = drawBuffer.getContext("2d");

    ctx.save();
    ctx.strokeStyle = "#D0D7E5"; //"#0000FF";
    //	ctx.fillStyle = "#FF0000";
    ctx.lineCap = "square";
    ctx.lineWidth = lineWidth;

    var sxadj;
    var syadj;
    var eyadj;
    var exadj;

    var adjuster = ThicknessAdjuster(lineWidth);
    sxadj = sx + adjuster;
    syadj = sy + adjuster;
    eyadj = ey - adjuster;
    exadj = ex - adjuster;

    switch (whichSegment) {
      case enumBorderLineType.leftBorder:
        performStroke(ctx, sxadj, syadj, sxadj, eyadj); // Left
        break;
      case enumBorderLineType.rightBorder:
        performStroke(ctx, exadj, syadj, exadj, eyadj); // Right
        break;
      case enumBorderLineType.topBorder:
        //	ctx.strokeStyle =  "#00FF00";
        performStroke(ctx, sxadj, syadj, exadj, syadj); // Top
        break;
      case enumBorderLineType.bottomBorder:
        //	ctx.strokeStyle =  "#00FF00";
        performStroke(ctx, sxadj, eyadj, exadj, eyadj); // Bottom
        break;
    }

    ctx.restore();
  }

  RenderCellBorderGrid(drawBuffer) {
    var cellDesc = this.fCellDesc;
    var gutterCell = cellDesc.IsGutterCell();

    var lineWidth = 1;
    var adjuster = ThicknessAdjuster(lineWidth);

    var sx = this.GetPositionX();
    var sy = this.GetPositionY();
    var ex = sx + this.GetWidth();
    var ey = sy + this.GetHeight();

    var sxadj = sx + adjuster;
    var syadj = sy + adjuster;
    var exadj = ex - adjuster;
    var eyadj = ey - adjuster;

    // Determine which segments to skip (gutter cell boundary logic)
    var skipLeft = false,
      skipRight = false,
      skipTop = false,
      skipBottom = false;
    if (gutterCell) {
      var rowIndex = cellDesc.GetRowIndex();
      var colIndex = cellDesc.GetColIndex();
      if (colIndex == 0) skipLeft = true;
      if (colIndex == this.fLayout.GetNumCols() + 1) skipRight = true;
      if (rowIndex == 0) skipTop = true;
      if (rowIndex == this.fLayout.GetNumRows() + 1) skipBottom = true;
    }

    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    ctx.strokeStyle = "#D0D7E5";
    ctx.lineCap = "square";
    ctx.lineWidth = lineWidth;
    ctx.beginPath();

    if (!skipLeft) {
      ctx.moveTo(sxadj, syadj);
      ctx.lineTo(sxadj, eyadj);
    }
    if (!skipRight) {
      ctx.moveTo(exadj, syadj);
      ctx.lineTo(exadj, eyadj);
    }
    if (!skipTop) {
      ctx.moveTo(sxadj, syadj);
      ctx.lineTo(exadj, syadj);
    }
    if (!skipBottom) {
      ctx.moveTo(sxadj, eyadj);
      ctx.lineTo(exadj, eyadj);
    }

    ctx.stroke();
    ctx.restore();
  }

  IsCellStatic() {
    //var isStatic = true;

    var cellDesc = this.fCellDesc;
    return cellDesc.IsCellStatic();

    /*
	var fieldDef = this.GetField();
	if (fieldDef == null)
		return isStatic;

	var displayMode = cellDesc.GetFieldDisplayMode();
	switch (displayMode)
	{
		case enumFieldDisplayMode.FieldOnly:
		case enumFieldDisplayMode.LabelAndField:
			isStatic = false;
			break;
	}

	return isStatic;
	*/
  }

  FormatFieldInfo(cellDesc, displayName) {
    var theContent = "";
    var displayMode = cellDesc.GetFieldDisplayMode();
    switch (displayMode) {
      case enumFieldDisplayMode.FieldOnly:
        theContent = "<" + displayName + ">";
        break;
      case enumFieldDisplayMode.LabelOnly:
        theContent = displayName + ":";
        break;
      case enumFieldDisplayMode.LabelAndField:
        theContent = displayName + ": <" + displayName + ">";
        break;
    }

    return theContent;
  }

  GetBoxStyleContent() {
    if (this.IsFreeText()) {
      theContent = this.GetFreeText(false);
      if (theContent === "") theContent = "<" + appstr("freetext") + ">";
      return theContent;
    }

    var cellDesc = this.fCellDesc;
    var theContent = cellDesc.GetFieldDisplayName();

    if (theContent != null && theContent != "")
      theContent = this.FormatFieldInfo(cellDesc, theContent);

    return theContent;
  }

  GetLayoutContent() {
    var cellDesc = this.fCellDesc;
    var fieldDef = this.GetField();
    var theContent;
    //var align = cellDesc.GetAlignment();

    if (fieldDef != null)
      theContent = this.FormatFieldInfo(cellDesc, fieldDef.GetFieldDisplayName());
    else {
      if (this.IsFreeText()) {
        theContent = this.GetFreeText();
        if (theContent === "") theContent = "<" + appstr("freetext") + ">";
      } else if (this.IsPicture()) {
        var picFile = cellDesc.GetSPictureFile();
        if (picFile == null) picFile = "Image Not Set";
        theContent = "<" + picFile + ">";
      } else theContent = "";
    }

    return theContent;
  }

  AltDrawPicture(altCanvas) {
    this.TEAltFill(altCanvas);

    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var r = this.TEAltGetClipRect();
    if (r == null) return;
    var layer = this.GetLayer();
    var pictureType = this.GetPictureType();

    var c = this.fCellDesc;
    var pictureMask = c.GetPictureMask();
    var picSource = c.GetPicSourceInfo();
    var isStatic = picSource.fDirectory !== "Temp";
    var theImage = this.fImage;
    const isXML = altCanvasType === "XML";
    const isIcon = pictureType === enumPictureType.iconPicture;
    const isFieldPicture = pictureType === enumPictureType.fieldPicture;

    if (
      (!isStatic && theImage == null && !(isInViewer() && isInStandardSubmode())) ||
      !isXML ||
      isIcon
    ) {
      if (c.fDeferredPicLoad) {
        c.fDeferredPicLoad = false;
        this.fImage = c.LoadCellPicture(this);
        theImage = this.fImage;
      }

      if (theImage == null) {
        var docRef = this.fLayout.GetDocRef();
        docRef.ReportPictureFault();
        return;
      }
    }

    var sx = r.fLeft;
    var sy = r.fTop;
    var w = r.fRight - r.fLeft;
    var h = r.fBottom - r.fTop;

    var sWidth = w;
    var sHeight = h;
    var addInset = false;
    let doHighRes = false;

    if (isFieldPicture && (theImage || isXML)) {
      var frameWidth = c.GetPictureFrameWidth(false);
      var frameHeight = c.GetPictureFrameHeight(false);

      if (c.fCellWidth < frameWidth) frameWidth = c.fCellWidth;
      if (c.fCellHeight < frameHeight) frameHeight = c.fCellHeight;

      if (theImage) {
        var iWidth = theImage.width;
        var iHeight = theImage.height;
        var scale;

        if (pictureMask === enumPicMask.circle) {
          scale = Math.min(frameWidth, frameHeight) / Math.min(iWidth, iHeight);
        } else {
          var scaleX = frameWidth / iWidth;
          var scaleY = frameHeight / iHeight;
          scale = Math.min(scaleX, scaleY);
        }

        sWidth = Math.floor(scale * iWidth);
        sHeight = Math.floor(scale * iHeight);
      } else {
        // No client-side pixel data, server-side scale_down fits the real image into this box.
        sWidth = frameWidth;
        sHeight = frameHeight;
      }

      addInset = true;
    } else if (isIcon) {
      sWidth = theImage.width;
      sHeight = theImage.height;
      doHighRes = true;
    }

    sx += this.GetPicShiftX(w, sWidth, addInset);
    sy += this.GetPicShiftY(h, sHeight, addInset);

    if (pictureMask == enumPicMask.grayscale && !isXML) {
      if (Globals._maskCanvas == null) Globals._maskCanvas = CreateCanvas();

      if (this.fMaskedImage == null) {
        Globals._maskCanvas.width = theImage.width;
        Globals._maskCanvas.height = theImage.height;
        ConvertToGrayscaleImage(theImage);

        var image = new Image();
        image.src = Globals._maskCanvas.toDataURL("image/png");
        this.fMaskedImage = image;

        var docRef = this.fLayout.GetDocRef();
        docRef.ReportPictureFault();
        return;
      }
      theImage = this.fMaskedImage;
    }

    var maskBorderColor = this.fLayout.GetBoxBorderColor();
    switch (altCanvasType) {
      case "SVG":
        SVG_DrawImage(
          sx,
          sy,
          sWidth,
          sHeight,
          r,
          pictureMask,
          maskBorderColor,
          theImage,
          layer,
          altCanvasElement,
          isIcon
        );
        break;
      case "XML":
        XML_DrawImage(
          sx,
          sy,
          sWidth,
          sHeight,
          r,
          pictureMask,
          this,
          altCanvasElement,
          layer,
          maskBorderColor,
          isIcon
        );
        break;
    }
  }

  GetPicShiftX(cellWidth, picWidth, addInset) {
    var inset = 0;
    if (addInset) inset = 2;
    var cx = inset;

    var alignment = this.TEGetAlignment(false);
    switch (alignment) {
      case "center":
        cx = CenterIt(cellWidth, picWidth);
        break;
      case "right":
        cx = cellWidth - picWidth - inset;
        break;
    }

    return cx;
  }

  GetPicShiftY(cellHeight, picHeight, addInset) {
    var inset = 0;
    if (addInset) inset = 2;
    var cy = inset;

    var vAlign = this.TEGetVAlignment();
    var txtVOffset;
    switch (vAlign) {
      case "middle":
        cy = CenterIt(cellHeight, picHeight);
        break;
      case "bottom":
        cy = cellHeight - picHeight - inset;
        break;
    }

    return cy;
  }

  GenerateMaskedImage(baseImage, picMask, drawBuffer) {
    var mWidth = 150;
    var mHeight = 150;

    if (Globals._maskCanvas == null) {
      Globals._maskCanvas = CreateCanvas();
    }
    if (picMask == enumPicMask.grayscale) {
      Globals._maskCanvas.width = baseImage.width;
      Globals._maskCanvas.height = baseImage.height;
      ConvertToGrayscaleImage(baseImage);
    } else {
      Globals._maskCanvas.width = mWidth;
      Globals._maskCanvas.height = mHeight;
      var ctx = Globals._maskCanvas.getContext("2d");
      var bWidth = baseImage.width;
      var bHeight = baseImage.height;
      var fillMode = this.TEGetFillMode();
      var fC = "#FFFFFF";
      if (fillMode == enumFillMode.solidFill) var fC = this.TEGetFillColor();
      ctx.fillStyle = fC;
      ctx.save();
      ctx.beginPath();
      ctx.arc(75, 75, 68, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.clip();

      var scaleX = mWidth / bWidth;
      var scaleY = mHeight / bHeight;
      var scale = Math.max(scaleX, scaleY);
      var sWidth = Math.floor(scale * bWidth);
      var sHeight = Math.floor(scale * bHeight);

      var cx = Div2Floor(mWidth - sWidth);
      var cy = Div2Floor(mHeight - sHeight);

      doDrawImage(ctx, baseImage, 0, 0, bWidth, bHeight, cx, cy, sWidth, sHeight);
      ctx.restore();
      var bStyle = this.fLayout.GetBoxBorderColor();
      ctx.beginPath();
      ctx.arc(75, 75, 68, 0, 2 * Math.PI, false);
      ctx.closePath();
      ctx.strokeStyle = bStyle; //"#35BDB2";
      ctx.lineWidth = 5;
      ctx.stroke();
    }
    const snapshot = document.createElement("canvas");
    snapshot.width = Globals._maskCanvas.width;
    snapshot.height = Globals._maskCanvas.height;
    snapshot.getContext("2d").drawImage(Globals._maskCanvas, 0, 0);
    return snapshot;
  }

  FinishDrawPicture(drawBuffer, image) {
    var iWidth = image.width;
    var iHeight = image.height;
    var c = this.fCellDesc;
    if (this.fClosed) return;

    var ctx = drawBuffer.getContext("2d");

    var cellWidth = this.GetWidth();
    var cellHeight = this.GetHeight();

    var pictureType = this.GetPictureType();
    var sWidth, sHeight;
    var scaleX, scaleY;
    var addInset = true;
    if (pictureType === enumPictureType.staticPicture) {
      scaleX = cellWidth / iWidth;
      scaleY = cellHeight / iHeight;

      sWidth = Math.floor(iWidth * scaleX);
      sHeight = Math.floor(iHeight * scaleY);
      addInset = false;
    } else {
      var frameWidth = c.GetPictureFrameWidth(false);
      var frameHeight = c.GetPictureFrameHeight(false);

      // Cap to cell dimensions (same as AltDrawPicture)
      if (c.fCellWidth < frameWidth) frameWidth = c.fCellWidth;
      if (c.fCellHeight < frameHeight) frameHeight = c.fCellHeight;

      var scale;
      var pictureMask = c.GetPictureMask();
      if (pictureMask === enumPicMask.circle) {
        scale = Math.min(frameWidth, frameHeight) / Math.min(iWidth, iHeight);
      } else {
        scaleX = frameWidth / iWidth;
        scaleY = frameHeight / iHeight;
        scale = Math.min(scaleX, scaleY);
      }
      sWidth = Math.floor(scale * iWidth);
      sHeight = Math.floor(scale * iHeight);
    }

    var cx = this.GetPicShiftX(cellWidth, sWidth, addInset) + this.GetPositionX();
    var cy = this.GetPicShiftY(cellHeight, sHeight, addInset) + this.GetPositionY();
    doDrawImage3(ctx, image, cx, cy, sWidth, sHeight);
  }

  DrawPicture(drawBuffer, altCanvas) {
    var c = this.fCellDesc;
    if (this.fImage == null) {
      if (c.fDeferredPicLoad) {
        c.fDeferredPicLoad = false;
        this.fImage = c.LoadCellPicture(this);
      }
      if (this.fImage == null) return;
    }

    var image = this.fImage;
    var pMask = c.GetPictureMask();
    if (pMask != enumPicMask.nomask) {
      if (this.fMaskedImage == null) {
        this.fMaskedImage = this.GenerateMaskedImage(image, pMask, drawBuffer);
      }
      image = this.fMaskedImage;
    }
    this.FinishDrawPicture(drawBuffer, image); // always draw - when masked image is reloaded - it will update reference to image. that way we dont have a render cycle with no drawing (polling flash)
  }

  GetWidthPositionX(buffer) {
    if (!buffer) buffer = 0;
    return this.GetPositionX() + this.GetWidth() + buffer;
  }

  EnumeratedTableCell() {
    var layout = this.GetLayout();
    return layout.GetBoxSubType() === enumBoxSubTypes.enumeratedTable;
  }

  HandleTableLoad() {
    // look to layout. if the layout is not able to grab table info from topbox, AND there is not an active RFC pending, need to grab table info for record and assign it to dbobj.
    var layout = this.GetLayout();
    var tableFieldRef = layout.GetAggregatedFieldRef();
    if (tableFieldRef) {
      var theDoc = layout.GetDocRef();
      var scm = theDoc.GetSubChartMgr();
      var sc = scm.GetActiveSubChart();
      var topObj = this.GetCellDesc().GetTopBoxRef();
      if (topObj == null) return;
      var recordTableData = topObj.fRecordDetails[tableFieldRef.GetFieldName()];
      if (recordTableData === undefined && layout.fDeferredTableLoad) {
        sc.fPageLoaded = false;
        layout.fDeferredTableLoad = false;
        var orgName = Globals._wsMgr.GetAccountName();
        var userName = Globals._wsMgr.GetUserName();

        var tableLoadRFC = new QRecordDetailsRFC();
        tableLoadRFC.InitDetailsQuery(topObj);
        tableLoadRFC.fLayout = layout;
        tableLoadRFC.fSCID = sc.GetSubChartID();
        var data = {
          tableName: tableFieldRef.GetFieldName(),
          PersonID: topObj.GetObjectRecordID(),
          chartID: Globals._svrChartMgr.GetChartID()
        };
        tableLoadRFC.SetParams(orgName, userName, "enumeratedTable", data);
        Globals._rfcMgr.QueueRFC(tableLoadRFC);
      }
    }
  }

  RenderTheContent(drawBuffer, inEditMode, txtFillStyle, altCanvas) {
    if (this.TreatAsPicture()) this.DrawPicture(drawBuffer, altCanvas);
    else if (this.GetCellDesc().GetCellContentType() == enumCellContentType.pieChart)
      this.DrawPieChart(drawBuffer, altCanvas, txtFillStyle);
    else if (this.TreatAsObject()) this.RenderObjectSeparators(drawBuffer, txtFillStyle);
    else {
      if (this.EnumeratedTableCell()) {
        this.HandleTableLoad();
      }
      this.RenderTheText(drawBuffer, inEditMode, txtFillStyle, altCanvas);
    }
  }

  // This function assumes objects have already been spaced and broken
  RenderObjectSeparators(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    if (this.fClippedRegion) {
      ctx.save();
      ctx.clip(this.fClippedRegion);
    }
    for (var eleIdx = 0; eleIdx < this.fElements.length; eleIdx++) {
      var anElement = this.fElements[eleIdx];
      var separatorX = anElement.GetPositionX() + anElement.GetWidth();
      var separatorY = anElement.GetPositionY();
      var eleSeparator = anElement.GetSeparator();
      this.TEDrawText(
        ctx,
        eleSeparator,
        separatorX,
        separatorY,
        this.TEGetFontColor(),
        -1,
        -1,
        "left",
        true,
        true
      );
    }
    if (this.fClippedRegion) ctx.restore();
  }

  AltRenderObjectSeparators(altCanvas) {
    var textColor = this.TEGetFontColor();
    var fontFamily = this.GetFontName();
    var fontSize = this.GetFontSize();
    var clipRect = this.TEAltGetClipRect();
    var bold = this.GetFontBold();
    var italic = this.GetFontItalic();
    var vAlignment = this.TEGetVAlignment();
    var hAlignment = this.TEGetAlignment();
    var layer = this.GetLayer();
    var altCanvasElement = altCanvas.GetCanvasElement();
    var altCanvasType = altCanvas.GetCanvasType();
    for (var eleIdx = 0; eleIdx < this.fElements.length; eleIdx++) {
      var anElement = this.fElements[eleIdx];
      var separatorX = anElement.GetPositionX() + anElement.GetWidth();
      var separatorY = anElement.GetPositionY();
      clipRect.fLeft = separatorX;
      clipRect.fTop -= 1;
      var eleSeparator = anElement.GetSeparator();

      separatorY += 1; // WHY IS THIS NECESSARY????
      if (altCanvasType === "SVG") {
        separatorY += 1;
        SVG_DrawText(
          eleSeparator,
          separatorX,
          separatorY,
          textColor,
          fontFamily,
          fontSize,
          bold,
          italic,
          false,
          "left",
          "top",
          clipRect,
          altCanvasElement
        );
      } else {
        vAlignment = "bottom";
        var docType = altCanvasElement.GetDocType();
        if (docType === enumXMLType.PDF) {
          vAlignment = "top";
          clipRect.fRight = clipRect.fRight =
            separatorX +
            MeasureText(eleSeparator, BuildFontString(fontFamily, fontSize, bold, italic));
        } else separatorY -= 2;
        XML_DrawText(
          eleSeparator,
          separatorX + 1,
          separatorY,
          textColor,
          fontFamily,
          fontSize,
          bold,
          italic,
          false,
          "left",
          vAlignment,
          clipRect,
          altCanvasElement,
          layer
        );
      }
    }
  }

  DrawPieChart(drawBuffer, altCanvas, txtFillStyle) {
    var ctx = drawBuffer.getContext("2d");

    var thickness = 1;
    if (this.GetLayout().GetAggregatedFieldRef()) {
      // may want a better check for this going forward...
      this.HandleTableLoad();
      this.GetCellDesc().GenerateAggregatedPieContent();
    } else this.GetCellDesc().BuildPieChartContent();

    ctx.save();
    //ctx.globalCompositeOperation="source-over";

    ctx.strokeStyle = kOCNDarkGrayColor;
    ctx.fillStyle = "#FFFFFF";
    ctx.lineWidth = thickness;
    ctx.lineJoin = "bevel";
    ctx.lineCap = "butt";
    ctx.lineWidth = 1;

    var pieSections = this.GetCellDesc().fPieSections;
    //var drawState = this.GetParentBox().GetDrawState();
    //if (drawState == enumElementDrawStates.Hover)
    //	console.log('hi');

    var width = this.GetWidth();
    var height = this.GetHeight();

    var cellDesc = this.fCellDesc;
    var displayMode = cellDesc.GetFieldDisplayMode();
    var drawLabel = true;
    switch (displayMode) {
      case enumFieldDisplayMode.FieldOnly:
        drawLabel = false;
        break;
    }
    var sx = this.GetPositionX() + Math.floor(width / 2);
    var sy = this.GetPositionY() + Math.floor(height * 0.45);
    var myField = this.GetField();
    if (drawLabel && myField) {
      ctx.fillStyle = txtFillStyle;
      ctx.textBaseline = "top";
      ctx.textAlign = "center";
      var fontString = this.TEGetFontString();
      ctx.font = fontString;
      var label = GetFieldLabel(myField);
      ctx.fillText(label, sx, this.GetPositionY());
    }

    var radius = width / 2.5 - 4;
    if (radius < 0) radius = 0;
    var angle = 0;

    //ctx.globalAlpha=0.7;
    //ctx.beginPath();
    if (pieSections == null || pieSections.length == 0) {
      ctx.beginPath();
      ctx.arc(sx, sy, radius, angle, 2 * Math.PI);
      ctx.closePath();
      ctx.stroke();
    } else {
      //var titleLength = ;
      for (var i = 0; i < pieSections.length; i++) {
        ctx.beginPath();
        var theSection = pieSections[i];
        var deltaAngle = 2 * Math.PI * (theSection["percent"] / 100);
        var finalAngle = angle + deltaAngle;
        ctx.fillStyle = theSection["color"];
        ctx.moveTo(sx, sy);
        var startPointY = sy + radius * Math.sin(angle);
        //var endPointY = sy + radius * Math.sin(finalAngle);
        var startPointX = sx + radius * Math.cos(angle);
        //var endPointX = sx + radius * Math.cos(finalAngle);
        ctx.lineTo(startPointX, startPointY);
        ctx.arc(sx, sy, radius, angle, finalAngle);
        ctx.lineTo(sx, sy);
        angle += deltaAngle;
        ctx.closePath();

        ctx.fill();
        ctx.stroke();
        //break;
      }
      var bottom = 2.05 * radius;
      sy = Math.ceil(sy + radius);
      var remainingSpace = height - bottom;
      var numlevels = Math.ceil(pieSections.length / 3);
      var textHeight = Math.min(Math.floor((remainingSpace - 6) / numlevels), 14);
      ctx.font = textHeight.toString() + "px Tahoma";
      sx = this.GetPositionX();
      if (textHeight < 6) {
        this.fCellDesc.fShowLegend = false;
        ctx.restore();
        return;
      }
      var rows = 1;
      var fontString = BuildFontString("Tahoma", textHeight, false, false);
      sy += 2;
      for (var i = 0; i < pieSections.length; i++) {
        var theSection = pieSections[i];
        ctx.fillStyle = theSection["color"];
        ctx.textBaseline = "top";
        ctx.textAlign = "left";
        var txtDim = Math.floor(ctx.measureText(theSection.value).width + 1.15 * textHeight);
        var labelSize = Math.min(txtDim, radius);
        if (sx + labelSize > this.GetPositionX() + width) {
          sy += textHeight + 4;
          sx = this.GetPositionX();
          rows += 1;
        }
        ctx.fillRect(sx, sy, textHeight, textHeight);
        ctx.fillStyle = txtFillStyle;
        theSection.value = TruncateText(theSection.value, fontString, labelSize);
        ctx.fillText(theSection.value, (sx += textHeight), sy);
        var buffer = Math.min(labelSize, MeasureText(theSection.value, fontString));
        sx += buffer + 4;
      }
      this.fCellDesc.fShowLegend = true;
      this.fCellDesc.fLegendRows = rows;
      this.fCellDesc.fLegendFontSize = textHeight;
    }
    ctx.restore();
  }

  TreatAsPicture() {
    var treatAsPicture = this.IsPicture();
    if (treatAsPicture) {
      var parentBoxMode = this.GetParentBoxMode();
      switch (parentBoxMode) {
        case enumChartBoxInteractionMode.layout:
        case enumChartBoxInteractionMode.marquee:
          treatAsPicture = this.GetPreviewMode();
          break;
        case enumChartBoxInteractionMode.boxstyle:
          treatAsPicture = false;
          break;
      }
    }

    return treatAsPicture;
  }

  TreatAsObject() {
    var treatAsObject = this.IsObject();
    if (!treatAsObject) return false;
    var displayMode = this.GetCellDesc().GetFieldDisplayMode();
    switch (displayMode) {
      case enumFieldDisplayMode.LabelOnly:
        treatAsObject = false;
        break;
      case enumFieldDisplayMode.hidden:
        treatAsObject = false;
        break;
    }
    var field = this.GetField();
    if (field != null) {
      var subType = field.GetFieldSubtype();
      if (subType == enumCellObjectSubtypes.objinfo) return false;
    }
    if (treatAsObject) {
      var parentBoxMode = this.GetParentBoxMode();
      switch (parentBoxMode) {
        case enumChartBoxInteractionMode.layout:
        case enumChartBoxInteractionMode.marquee:
          treatAsObject = this.GetPreviewMode();
          break;
        case enumChartBoxInteractionMode.boxstyle:
          treatAsObject = false;
          break;
      }
    }
    return treatAsObject;
  }

  GetDataObj() {
    return this.fDataObj;
  }

  GetDataObjID() {
    if (this.fDataObjID == null) {
      var d = this.GetDataObj();
      if (d != null) this.fDataObjID = d.fDataObjID;
    }

    return this.fDataObjID;
  }

  // Get the current cell value from the ObjectDB
  RetrieveEditContent() {
    var t = "";
    if (this.IsFreeText()) {
      t = this.GetFreeText(false);
      return t;
    }

    var fieldDef = this.GetField();
    if (fieldDef == null) return t;

    var dataObj = this.GetDataObj();
    if (dataObj == null) return t;

    var dataVal = dataObj.GetFieldValue(fieldDef);
    if (dataVal == null) dataVal = "";

    return dataVal;
  }

  FieldReadOnly() {
    var fieldDef = this.GetField();
    if (fieldDef != null && !fieldDef.FieldReadOnly()) return false;

    return true;
  }

  CommitEditContent(newContent) {
    var curValue;
    var changed = false;
    var w = Globals._wsMgr;
    if (w == null || w.GetDoc() == null) {
      return;
    }

    if (this.IsFreeText()) {
      curValue = this.GetFreeText(false);
      if (curValue != newContent) {
        const doc = w.GetDoc();
        const layoutMgr = doc.GetLayoutMgr();
        var l = this.fLayout;
        //var scNodeRef = l.GetSCNodeRef();
        w.StartCheckPoint();
        this.SetFreeText(newContent);
        if (this.GetParentBoxMode() === enumChartBoxInteractionMode.content) {
          layoutMgr?.UpdateOverrideInfo(l);
        }
        w.EndCheckPoint();
        changed = true;
      }
    } else {
      var fieldDef = this.GetField();
      var isEditableField = this.IsEditableField(fieldDef);
      if (!isEditableField) return changed;

      var dataObj = this.GetDataObj();
      curValue = dataObj.GetFieldValue(fieldDef);
      if (curValue == null) curValue = "";

      changed = curValue != newContent;
      if (!changed) return changed;

      w.StartCheckPoint();
      var doc = w.GetDoc();
      var fieldName = fieldDef.GetFieldName();
      var changeObj = {};
      changeObj["data"] = {};
      var data = changeObj["data"];
      data[fieldName] = newContent;
      doc.SetBoxOverride(dataObj, enumOverrideType.change, changeObj);
      w.EndCheckPoint();
    }

    var parentBox = this.GetParentBox();
    parentBox.ForceLayoutRecalc(true);
    parentBox["ForceChartLayout"] = true;

    return changed;
  }

  GetAutoTextType() {
    var cellDesc = this.fCellDesc;
    return cellDesc.GetAutoTextType();
  }

  CacheAutoText() {
    var cellDesc = this.fCellDesc;
    var newValue = cellDesc.GetDisplayContent();

    var changed = false;
    if (newValue != this.fAutoTextCache) {
      this.fAutoTextCache = newValue;
      changed = true;
    }

    return changed;
  }

  GetEscBreakChars() {
    var cellDesc = this.fCellDesc;
    return cellDesc.GetEscBreakChars();
  }

  ReloadPic() {
    this.fImage = null;
    this.fMaskedImage = null;
    var cellDesc = this.fCellDesc;
    cellDesc.ReloadPic();
  }

  GetLinkContent(hasLabel) {
    var cellDesc = this.fCellDesc;
    return cellDesc.GetLinkContent(hasLabel);
  }

  GetDisplayContent() {
    if (this.IsFreeText()) return this.GetFreeText(true);

    if (this.IsAutoText()) return this.fAutoTextCache;

    //var fieldDef = this.GetField();
    //var dataObj = this.GetDataObj();

    //var f = GetFieldDisplayInfo(fieldDef, dataObj);

    var cellDesc = this.fCellDesc;
    return cellDesc.GetDisplayContent(); //f.displayName,f.fieldValue , f.containsField
  }

  // Override from QTextEdit
  TEGetFontString() {
    var cellDesc = this.fCellDesc;
    var txtFormat = cellDesc.GetTextFormat();
    var fontString = txtFormat.BuildFontString();

    return fontString;
  }

  GetFontSize() {
    var cellDesc = this.fCellDesc;
    var fontSize = cellDesc.GetFontSize();
    return fontSize;
  }

  GetFontName() {
    var cellDesc = this.fCellDesc;
    var fontName = cellDesc.GetFontName();
    return fontName;
  }

  GetFontBold() {
    var cellDesc = this.fCellDesc;
    var isBold = cellDesc.GetTextBold();
    return isBold;
  }

  SetFontBold(bold) {
    var cellDesc = this.fCellDesc;
    cellDesc.SetTextBold(bold);
  }

  SetFontItalic(italic) {
    var cellDesc = this.fCellDesc;
    cellDesc.SetTextItalic(italic);
  }

  GetFontItalic() {
    var cellDesc = this.fCellDesc;
    var isItalic = cellDesc.GetTextItalic();
    return isItalic;
  }

  GetFontUnderlined(bypass) {
    if (!bypass && this.TreatAsObject()) return false;
    var cellDesc = this.fCellDesc;
    var isUnderlined = cellDesc.GetTextUnderline();
    return isUnderlined;
  }

  TEGetAlignment(includeJustify) {
    var cellDesc = this.fCellDesc;
    var align = cellDesc.GetAlignment();

    if (!includeJustify) {
      if (align == "justify") align = "left";
    }

    return align;
  }

  // TODO: Override this for QChartBoxCell instead? This will allow all text edits to be set to bold/italic
  TEHandleCtrlShortCut(keyInfo) {
    var charCode = keyInfo.charCode;
    var keyChar = String.fromCharCode(charCode);
    var handled = true;

    switch (keyChar) {
      case "a":
        this.SelectAll();
        break;
      case "b":
        this.SetFontBold(!this.GetFontBold());
        break;
      case "i":
        this.SetFontItalic(!this.GetFontItalic());
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  TEGetVAlignment() {
    var cellDesc = this.fCellDesc;
    var vAlign = cellDesc.GetVAlignment(true);

    return vAlign;
  }

  TEGetFontColor() {
    var cellDesc = this.fCellDesc;
    var txtFormat = cellDesc.GetTextFormat();
    var txtFillStyle = txtFormat.GetFontColor();

    return txtFillStyle;
  }

  TEGetFillMode() {
    var cellDesc = this.fCellDesc;
    var fillMode = cellDesc.GetCellFillMode();
    return fillMode;
  }

  TEGrayDisabledText() {
    return false;
  }

  TEGetFillColor() {
    var cellDesc = this.fCellDesc;
    var fillColor = cellDesc.GetCellFillColor();

    return fillColor;
  }

  TEGetFillColor2() {
    var cellDesc = this.fCellDesc;
    var fillColor = cellDesc.GetCellFillColor2();

    return fillColor;
  }

  TERenderText() {
    var cellDesc = this.fCellDesc;
    var gutterCell = cellDesc.IsGutterCell();

    return !gutterCell;
  }

  TEGetBreakChars() {
    return this.GetEscBreakChars();
  }

  TEGetContentToRender() {
    //return 'col: ' + this.fCellDesc.GetColIndex() + ' row: ' + this.fCellDesc.GetRowIndex()
    var theField = this.GetField();
    var inEditMode = this.InEditMode();
    var hasBlankMsg = false;

    if (theField != null || this.IsFreeText()) hasBlankMsg = true;

    var theContent = "";

    if (inEditMode) {
      theContent = this.GetEditContent();
    } else {
      var parentBoxMode = this.GetParentBoxMode();
      switch (parentBoxMode) {
        case enumChartBoxInteractionMode.layout:
        case enumChartBoxInteractionMode.marquee:
          theContent = this.GetDisplayContent();
          if (this.GetPreviewMode() || this.IsFreeText()) {
            theContent = this.GetDisplayContent();
            if (theContent.length === 0) theContent = this.GetLayoutContent();
          } else theContent = this.GetLayoutContent();
          break;
        case enumChartBoxInteractionMode.boxstyle:
          theContent = this.GetBoxStyleContent();
          break;
        case enumChartBoxInteractionMode.content:
        case enumChartBoxInteractionMode.readOnly:
          theContent = this.GetDisplayContent();
          break;
      }
    }

    if (theContent == null) return "";

    if (theContent.length == 0 && hasBlankMsg) {
      if (!inEditMode && this.IsSelected()) {
        var blankMsg = null;
        if (theField != null) blankMsg = "<" + theField.GetFieldDisplayName() + ">";
        else if (this.IsFreeText() && this.GetFreeText() === "")
          blankMsg = "<" + appstr("freetext") + ">";

        if (blankMsg != null) theContent = blankMsg;
      }
    }

    return theContent;
  }

  TERenderExtras(drawBuffer) {
    if (this.RenderBorderGrid()) this.RenderCellBorderGrid(drawBuffer);
  }

  TEClipToParent(drawBuffer) {
    if (!this.fCellEditMode) {
      var forceClip = this.GetForceClip();
      if (forceClip) {
        var p = this.fParentBox;
        p.SetChartBoxClip(drawBuffer);
      }
    }
  }

  InEditMode() {
    return this.fCellEditMode;
  }

  RenderBorderGrid() {
    return this.fRenderBorderGrid;
  }

  SetRenderBorderGrid(renderGrid) {
    this.fRenderBorderGrid = renderGrid;
  }

  InteractFieldDrag(canvasX, canvasY, panelX, panelY, shiftDown) {
    if (shiftDown) {
      if (this.IsSelectable()) {
        // Selectable elements have this behavior implemented within
        // the mouse down handler
        return false;
      }

      var selectIt = this.IsSelected();
      this.fParentPanelRef.DoSelectElement(this, !selectIt);
      return false;
    }

    var grabberLeft = 0;
    var grabberRight = this.GetWidth();
    var grabberTop = 0;
    var grabberBottom = this.GetHeight();

    var elementX = panelX - this.GetPositionX();
    var elementY = panelY - this.GetPositionY();

    if (elementX >= grabberLeft && elementX <= grabberRight) {
      if (elementY >= grabberTop && elementY <= grabberBottom) {
        // Create the panel
        this.fParentBox.StartFieldDrag(this, canvasX, canvasY);
        return true;
      }
    }

    return false;
  }

  GetParentBox() {
    return this.fParentBox;
  }

  GetParentBoxMode() {
    var parent = this.GetParentBox();
    var editMode = parent.GetBoxMode();
    return editMode;
  }

  StartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    var boxMode = this.GetParentBoxMode();
    switch (boxMode) {
      case enumChartBoxInteractionMode.content:
        return this.DoStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown);
        break;
      case enumChartBoxInteractionMode.readOnly:
        break;
      case enumChartBoxInteractionMode.layout:
        var TEInteraction = this.IsFreeText() && this.InEditMode();
        this.SetWantsKeyboardInput(TEInteraction);
        if (TEInteraction)
          // for free text cells - we will trigger the drag field behavior with shift down + mouse down
          return this.DoStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown);
        else return this.InteractFieldDrag(canvasX, canvasY, panelX, panelY, shiftDown);
        break;
      case enumChartBoxInteractionMode.boxstyle:
      case enumChartBoxInteractionMode.marquee:
        break;
    }

    return false;
  }

  UpdateCellProperty(parameter, property, doOverride = true) {
    var cellDesc = this.GetCellDesc();
    //	var currentContent = this.GetDisplayContent();
    var needsRecalc = cellDesc.UpdateBoxCellDesc(parameter, property, doOverride); // , currentContent);
    let layout = this.fLayout;
    let doc = this.fParentPanelRef.fDoc;

    if (doOverride) {
      doc.GetLayoutMgr().UpdateOverrideInfo(layout);
      this.fParentBox.RemoveOverlay(QBoxOverlay_Wand);
      if (layout.HasOverrides()) {
        this.fParentBox.AddElement(enumBoxOverlay.wand);
        needsRecalc = true;
      }
    }
    return needsRecalc;
  }

  CacheContent() {
    var curString = this.RetrieveEditContent();
    this.SetEditContent(curString);
  }

  EnterEditMode(x, y) {
    var cellStatic = this.IsCellStatic();
    const fieldDef = this.GetField();
    const isPosField = fieldDef?.IsPositionField() && fieldDef?.fFormulaRule === null;
    var inEditMode = false;

    if (fieldDef) {
      const isEditable = this.IsEditableField(fieldDef);
      if (!isEditable) {
        this.ShowFieldNotEditableToast();
        return false;
      }
    }

    if (cellStatic == false || isPosField) {
      this.fCellEditMode = true;
      Globals._timerMgr.StartTimer(this, false);

      var curString = this.RetrieveEditContent();
      this.SetEditContent(curString);

      if (x == null) this.SelectAll();
      else this.FindInsertionPoints(x, y);

      this.SetIsControl(true);
      this.SetDblClickCmd("CellSelectAll"); // Should do a select all

      // Makes sure it is on top while we are editing
      var parentBox = this.GetParentBox();
      parentBox["activebox"] = true;
      //	parentBox.SetZPlane(enumChartRenderOrder.activeBox);
      this.TEStartEdit();
      inEditMode = true;
    }

    return inEditMode;
  }

  DoExitKeyboardTarget(targetPanel, previousPanel) {
    // The reason this happens is if the keyboard target is moving to another panel
    if (this.fCellEditMode && previousPanel != targetPanel) {
      //    console.log("Deselecting Active Cell");
      previousPanel.DoSelectElement(this, false);
    } //thePanel.ClearSelection();
  }

  ExitEditMode(discardChanges) {
    //console.log("ExitEditMode");
    if (this.fCellEditMode == false) {
      console.log("Double ExitEditMode");
      return;
    }

    this.fCellEditMode = false;
    Globals._timerMgr.ClearTimer();

    this.TEFinishEdit();

    // There are cases where we don't commit the edit content (Esc)
    var cellContentChanged = false;
    if (!discardChanges) {
      cellContentChanged = this.CommitEditContent(this.GetEditContent());
      var parentBox = this.GetParentBox();
      parentBox["activebox"] = false;

      if (cellContentChanged) {
        parentBox.SetDocDirty();
        // TEMPORARY - need cleaner approach
        if (parentBox.GetLayer() === enumElementLayer.master) {
          Globals._wsMgr.fCanvasPanel?.UpdateLayoutBackgroundMgr(parentBox.GetLayout());
        }
      }
    }

    if (this.GetParentBoxMode() !== enumChartBoxInteractionMode.layout) this.SetIsControl(false);

    this.SetDblClickCmd("EditCellContent");

    this.fCanUndo = false;
    this.fRedoContent = null;

    return cellContentChanged;
  }

  IsEditableField = fieldDef => {
    if (!fieldDef) return false;

    const isCalc = fieldDef.GetCalcCode() != null;
    const fieldReadOnly = fieldDef.FieldReadOnly();
    const internalOnly = fieldDef.GetInternalOnly();
    const classDef = fieldDef.GetParentClass();
    const targetFieldID = fieldDef.GetFieldID();
    const recordIDFieldDef = classDef.GetRecordIDFieldDef();
    const hierarchyFieldID = recordIDFieldDef.GetFieldID();

    return !isCalc && !fieldReadOnly && !internalOnly && targetFieldID !== hierarchyFieldID;
  };

  ShowFieldNotEditableToast() {
    Globals._wsMgr?.BroadcastTopic("add-toast", {
      message: appstr("This field is read-only and cannot be edited"),
      status: "info"
    });
  }

  DoEnterKeyboardTarget(enterAction) {
    //console.log("EnterKeyboardTarget");
  }

  ElementHandleKeyboard(keyInfo) {
    //var charCode = event.charCode;
    //var modKeys = EventToModKeys(event);
    var ctrlKey = keyInfo.ctrlKey;
    var keyCode = keyInfo.keyCode;
    var charCode = keyInfo.charCode;

    //if (charCode == 0)
    //	return false;

    var inEditMode = this.InEditMode();
    if (inEditMode) {
      //if (ctrlKey)		// Eat the ctrlKey if already editing
      //	return true;
      switch (keyCode) {
        case kEscKey:
          inEditMode = this.ExitEditMode(true);
          break;
        default:
          break;
      }
    } else {
      //if (ctrlKey)		// Bubble the ctrlKey Up to the next level
      //	return false;
      switch (charCode) {
        case kTabKey:
        case kReturnKey:
          break;
        default:
          inEditMode = this.EnterEditMode(null, null);
          break;
      }
    }

    var handled = false;
    if (inEditMode) handled = this.TEHandleKeyboard(keyInfo); // event, keySource);

    return handled;
  }

  HoverTarget(becomeTarget) {
    var p = this.GetParentBox();
    if (p) p.HoverTarget(becomeTarget);
  }

  GetNumRows(limited) {
    // Don't wrap when editing a cell
    //if (this.InEditMode())
    //	return 1;
    //else
    return this.fCellDesc.GetCellNumRows(limited);
  }

  Match(findStr, replaceStr) {
    var dataObj = this.GetDataObj();
    var fieldDef = this.GetField();
    var dataVal = "";
    if (fieldDef != null) {
      var dataVal = dataObj.GetFieldValue(fieldDef);
      if (dataVal == null) return false;
    }

    var regEx = CreateRegExpression(findStr, true);

    if (typeof dataVal != "string") dataVal = dataVal.toString();
    if (dataVal.match(regEx) == null) return false;
    else {
      if (replaceStr != null) {
        dataVal = dataVal.replace(regEx, replaceStr);
        dataObj.SetFieldValue(fieldDef, dataVal);
      }

      return true;
    }
  }

  //=================================================================================================
  GetReturnNewline() {
    return false;
  }

  //=================================================================================================
  // Debugging
  ObjectName() {
    return this.fObjectName; // "QChartBoxCell";
  }

  //=================================================================================================
  // RenderSVG
  DoAltRender(altCanvas) {
    var txtFillStyle = this.TEGetFontColor();
    if (this.IsPicture()) {
      this.AltDrawPicture(altCanvas);
    } else if (this.IsChart()) {
      if (this.GetLayout().GetAggregatedFieldRef()) {
        // may want a better check for this going forward...
        this.HandleTableLoad();
        this.GetCellDesc().GenerateAggregatedPieContent();
      } else this.GetCellDesc().BuildPieChartContent();
      this.AltDrawChart(txtFillStyle, altCanvas);
    } else if (this.IsObject()) {
      this.TEAltFill(altCanvas);
      this.AltRenderObjectSeparators(altCanvas);
    } else {
      var cellDesc = this.fCellDesc;
      var gutterCell = cellDesc.IsGutterCell();
      var fillMode = cellDesc.GetCellFillMode();
      if (!gutterCell || fillMode !== enumFillMode.noFill) {
        if (this.EnumeratedTableCell()) {
          this.HandleTableLoad();
        }
        this.RenderTheText(null, false, txtFillStyle, altCanvas);
      }
    }
  }

  AltDrawChart(txtFillStyle, altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var r = this.TEAltGetClipRect();
    if (r == null) return;

    var data = this.GetCellDesc().fPieSections;

    var doLegend = !!this.fCellDesc.fShowLegend;
    switch (altCanvasType) {
      case "SVG":
        SVG_DrawCellChart(this, r, doLegend, txtFillStyle, altCanvasElement);
        break;
      case "XML":
        var isPDF = altCanvasElement.GetDocType() === enumXMLType.PDF;
        var width = this.GetWidth();
        var radius = width / 2.5 - 4;
        var bottom = 2.05 * radius;
        var remainingSpace = this.GetHeight() - bottom;
        var numlevels = Math.ceil(data.length / 3);
        var textHeight = Math.min(Math.floor((remainingSpace - 6) / numlevels), 14);
        var doLegend = true;
        if (textHeight < 6) {
          doLegend = false;
        }
        if (isPDF)
          XML_DrawCellChartPDF(this, r, data, doLegend, textHeight, txtFillStyle, altCanvasElement);
        else
          XML_DrawCellChartPPT(this, r, data, doLegend, textHeight, txtFillStyle, altCanvasElement);

        break;
    }
  }

  TEGetContainerBoundry() {
    var p = this.GetParentBox();

    var sx = p.GetPositionX();
    var sy = p.GetPositionY();
    var w = p.GetWidth();
    var h = p.GetHeight();
    var r = new QRect();
    r.InitRect(sx, sy, sx + w, sy + h);
    return r;
  }

  TERightIndent() {
    var c = this.GetCellDesc();
    return this.fLayout.GetRightInset(c, 0);
  }

  TELeftIndent() {
    var c = this.GetCellDesc();
    return this.fLayout.GetLeftInset(c, 0);
  }

  CreateClipRegion(sx, sy, ex, ey) {
    //sx += this.TELeftIndent();
    //ex -= this.TERightIndent();
    this.fTheClippedRegion = CreatePath2D(sx, sy, ex, ey);
    this.fClippedRegionCoords = { sx: sx, sy: sy, ex: ex, ey: ey };
  }

  //=================================================================================================
  // Free Text
  GetFreeText(resolveRef) {
    var c = this.GetCellDesc();
    var t = c.GetFreeRefText(resolveRef);
    if (t == null) t = "";
    return t;
  }

  SetFreeText(freeText) {
    var c = this.GetCellDesc();
    let parentBox = this.GetParentBox();
    var shouldOverride = parentBox.ShouldDoOverrides();
    return shouldOverride && this.GetParentBoxMode() === enumChartBoxInteractionMode.content
      ? c.SetOverrideFreeText(freeText)
      : c.SetFreeText(freeText);
  }

  IsFreeText() {
    var c = this.GetCellDesc();
    return c.IsFreeText();
  }

  IsPicture() {
    var c = this.GetCellDesc();
    return c.IsPicture();
  }

  IsObject() {
    var c = this.GetCellDesc();
    return c.IsObject();
  }

  ObjectSubtype() {
    var c = this.GetCellDesc();
    return c.GetCellObjectSubtype();
  }

  IsChart() {
    var c = this.GetCellDesc();
    return c.IsChart();
  }

  IsAutoText() {
    var c = this.GetCellDesc();
    return c.IsAutoText();
  }

  SetCellContentType(contentType) {
    var c = this.GetCellDesc();
    c.SetCellContentType(contentType);
  }

  IsShown() {
    var shown = this.fShown;

    if (shown) {
      var c = this.GetCellDesc();
      return !c.IsHidden();
    } else return false;
  }

  //=================================================================================================
  // Tablet/iPhone/iPad
  WantsOnscreenKeypad() {
    return true;
  }
}
